/*
 * File: 客户明细
 */
<template>
    <div>
        <table-box
            ref="tableBox"
            :height="config.height"
            :selection="config.selection"
            :index="config.index"
            :columns="config.columns"
            :actions="config.actions"
            v-loading="customerList.tableLoading"
            :rows="customerList.totalData"
        />
        <div class="footer">
            <lots-pagination
                @size-change="customerList.sizeChange"
                :current-page.sync="customerList.pageNo"
                @current-change="customerList.pageChange"
                size="small"
                layout="total, sizes, prev, pager, next, jumper"
                :total="customerList.pageTotal"
            />
        </div>
    </div>
</template>

<script>
import { watch, reactive } from '@vue/composition-api';
import tableBox from '@/components/lots/tableBox/Index';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import { getCustomerPage } from '@mdm/api/customer/customerManage.js';
import { tableConfig } from './config.js';

export default {
    components: {
        lotsPagination, tableBox
    },
    props: {
        activeName: {
            type: String,
            default: () => ''
        },
        detailData: {
            type: Object,
            return: () => { }
        }
    },
    setup(props, setupContext) {
        const config = reactive(tableConfig);
        class CustomerDetailClass extends AdvanceListClass {
            beforeGetList(condition) {
                condition.customerGroupCode = props.detailData.customerGroupCode;
                return condition;
            }
            afterGetList(res) {
                if (+res.code === 0 && res.data && res.data.list) {
                    customerList.totalData.value = res.data.list;
                    customerList.pageTotal.value = res.data.totalCount;
                }
            }
        };
        const customerList = new CustomerDetailClass({
            Api: {
                listApi: getCustomerPage
            }
        });

        watch(
            () => [props.activeName, props.detailData],
            (val) => {
                customerList.totalData.value = [];
                customerList.pageTotal.value = 0;
                if (val[0] === 'customerDetail' && val[1].customerGroupCode) {
                    customerList.getList();
                }
            },
            { immediate: true } // 不设置的话，初始化加载时不会执行
        );
        return {
            config,
            customerList
        };
    }
};
</script>

<style lang="less" scoped>
.footer {
    padding: 10px 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
</style>
